import { Button, DatePicker } from 'antd'
import dayjs from 'dayjs';
import React, { useState } from 'react'

function OrderReport() {
    const [from, setFrom] = useState(dayjs().format('YYYY-MM-DD'));
    const [to, setTo] = useState(dayjs().format('YYYY-MM-DD'));

    const generateReport = () => {
        console.log(from);
        console.log(to);
    }

    return (
        <div>
            <div className="px-4 border pb-6 bg-white pop-left">
                <div className='flex items-center gap-2 pt-5'>
                    <div>From: <DatePicker defaultValue={dayjs()} onChange={(val) => setFrom(val.format('YYYY-MM-DD'))} /></div>
                    <div>To: <DatePicker defaultValue={dayjs()} onChange={(val) => setTo(val.format('YYYY-MM-DD'))} /></div>
                    <div className='pl-1'><Button onClick={generateReport}>Download</Button></div>
                </div>
            </div>
        </div>
    )
}

export default OrderReport